<template>
    <div>
        <div class="pagination" v-if="applications.query.pageTotal > 1">
              <button
                v-if="applications.query.pageNumber > 1"
                @click="
                  triggerSearch(
                    applications.search.typing,
                    applications.query.pageNumber - 1
                  )
                ">
                &lt;
              </button>
              <button
                v-if="applications.query.pageNumber > 1"
                @click="triggerSearch(applications.search.typing, 1)">
                1
              </button>
              <span v-if="applications.query.pageNumber > 3">...</span>
              <button
                v-if="applications.query.pageNumber - 2 > 1"
                @click="
                  triggerSearch(
                    applications.search.typing,
                    applications.query.pageNumber - 2
                  )
                ">
                {{ applications.query.pageNumber - 2 }}
              </button>
              <button
                v-if="applications.query.pageNumber - 1 > 1"
                @click="
                  triggerSearch(
                    applications.search.typing,
                    applications.query.pageNumber - 1
                  )
                ">
                {{ applications.query.pageNumber - 1 }}
              </button>
              <button class="xclicked">
                {{ applications.query.pageNumber }}
              </button>
              <button
                v-if="
                  applications.query.pageNumber + 1 <
                  applications.query.pageTotal
                "
                @click="
                  triggerSearch(
                    applications.search.typing,
                    applications.query.pageNumber + 1
                  )
                ">
                {{ applications.query.pageNumber + 1 }}
              </button>
              <button
                v-if="
                  applications.query.pageNumber + 2 <
                  applications.query.pageTotal
                "
                @click="
                  triggerSearch(
                    applications.search.typing,
                    applications.query.pageNumber + 2
                  )
                ">
                {{ applications.query.pageNumber + 2 }}
              </button>
              <span
              class="pagination__dots"
                v-if="
                  applications.query.pageNumber <
                  applications.query.pageTotal - 2
                "
                >...</span
              >
              <button
                v-if="
                  applications.query.pageTotal > 1 &&
                  applications.query.pageNumber < applications.query.pageTotal
                "
                @click="
                  triggerSearch(
                    applications.search.typing,
                    applications.query.pageTotal
                  )
                ">
                {{ applications.query.pageTotal }}
              </button>
              <button
                v-if="
                  applications.query.pageNumber < applications.query.pageTotal
                "
                @click="
                  triggerSearch(
                    applications.search.typing,
                    applications.query.pageNumber + 1
                  )
                ">
                >
              </button>
            </div>
    </div>
</template>

<script setup lang="ts">
import { ref, PropType} from "vue";
import { useRouter } from "vue-router";

const props = defineProps({
    applications: {
        type: Object as PropType<any>,
        required: true
    },
    triggerSearch: {
        type: Function,
        required: true
    },
  pageNumber: {
    type: Number,
    required: false
  },
    pageTotal: {
        type: Number,
        required: true
    }
});

</script>

<style scoped>
.pagination__dots {
  margin: 0 10px 0 5px;
}
</style>